import axios from 'axios';

const API_BASE_URL = `${process.env.REACT_APP_API_BASE_URL}/reglement`;// Adjust the base URL based on your actual backend URL

export const createReglement = (reglementData) => axios.post(`${API_BASE_URL}/create`, reglementData);
export const getReglementById = (id) => axios.get(`${API_BASE_URL}/get/${id}`);
export const updateReglement = (id, reglementData) => axios.put(`${API_BASE_URL}/update/${id}`, reglementData);
export const deleteReglement = (id) => axios.delete(`${API_BASE_URL}/delete/${id}`);
export const getAllReglements = () => axios.get(`${API_BASE_URL}/all`);
export const createReglementDetailsBatch = (regDetailsArray) => axios.post(`${API_BASE_URL}/createBatchDetails`, regDetailsArray);

export const getAllUnifiedFactureAvoir = (params) => {
  if (!params || !params.code_clt) {
    return Promise.resolve({ data: [] });
  }
  return axios.get(`${API_BASE_URL}/getAllUnified/${params.code_clt}`);
};

export const addDetailReglement = (regDetailData) => axios.post(`${API_BASE_URL}/addDetail`, regDetailData);


export const deleteReglementDetail = (refRegV, refAvFac) => {
    return axios.delete(`${API_BASE_URL}/deletedetail/${refRegV}/${refAvFac}`);
  };


  // Add this to your existing regAPI.js file
export const saveReglement = (reglementData) => axios.post(`${API_BASE_URL}/savereglement`, reglementData);


export const createSurplus = (surplusData) => 
  axios.post(`${API_BASE_URL}/surplus/create`, surplusData);

export const unvalidateSurplus = (refSurplus) => 
  axios.delete(`${API_BASE_URL}/surplus/unvalidate/${refSurplus}`);

export const seedFacven = () => axios.post(`${API_BASE_URL}/seed/facven`);

export const seedFacvenTwoPhase = (phase, filePath = null, ftpFileDate = null) => 
  axios.post(`${API_BASE_URL}/seed/facven-twophase`, { phase, filePath, ftpFileDate });

export const correctUnifiedFactureAvoir = () => axios.post(`${API_BASE_URL}/correct-unified`);